

@if(showLightbox){
<div class="lightboxWrapper"

>
  <div class="lightbox-content">

    <button class="lightbox-close" (click)="close()">
      <i-icon [name]="'x-mark'" class="!tw-block"></i-icon>
    </button>
    <button class="lightbox-slide lightbox-slide-prev" *ngIf="showNavigation && currentIndex > 0" (click)="prev()">
      <i-icon [name]="'arrow-back'" class="!tw-block"></i-icon>
    </button>
    <button class="lightbox-slide lightbox-slide-next" *ngIf="showNavigation && currentIndex < images.length - 1" (click)="next()">
      <i-icon [name]="'arrow-forward'" class="!tw-block"></i-icon>
    </button>
   
      <img [@fadeSlide]="currentIndex" [src]="images[currentIndex]" class="tw-max-h-full tw-max-w-full tw-rounded-2xl tw-transition-transform tw-duration-1000 tw-ease-in-out" alt="lightbox-{{currentIndex}}"
      (mousedown)="onDragStart($event)"
      (mousemove)="onDragMove($event)"
      (mouseup)="onDragEnd()"
      (mouseleave)="onMouseLeave()"
      (touchstart)="onDragStart($event)"
      (touchmove)="onDragMove($event)"
      (touchend)="onTouchEnd()"
      />

  </div>
</div>
}